(function () {
  function copyURI(e, copyLink) {
    e.preventDefault();

    const url = copyLink.dataset.copyHref || window.location.href;

    const handleCopy = (btn, success) => {
      if (success) {
        btn.classList.add("copied");
        setTimeout(() => btn.classList.remove("copied"), 1000);
      } else {
        btn.classList.add("notCopied");
        setTimeout(() => btn.classList.remove("notCopied"), 1000);
      }
    };

    function fallbackCopy(url, copyLink) {
      const textArea = document.createElement("textarea");
      textArea.value = url;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        handleCopy(copyLink, document.execCommand("copy"));
      } catch {
        handleCopy(copyLink, false);
      }

      document.body.removeChild(textArea);
    }

    // Modern Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(url)
        .then(() => handleCopy(copyLink, true))
        .catch(() => fallbackCopy(url, copyLink));
    } else {
      // Fallback for unsupported browsers
      fallbackCopy(url, copyLink);
    }
  }

  document.body.addEventListener("click", function (e) {
    const copyBtn = e.target.closest(".copy-btn");

    if (!copyBtn) return;

    copyURI(e, copyBtn);
  });
})();
